<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/64/image-drag.svg" size="2"></app-svg>

  <h1>Manual Order</h1>
  <p>There are over 100 assets. Are you sure you want to turn off automatic sorting?</p>

  <button
    appButton
    name="confirm"
    location="manual-confirm-dialog"
    color="primary"
    data-test-id="delete-confirmation"
    (click)="close(true)"
    height="4"
    size="3"
    weight="bold"
    shape="round"
    spacing="full"
  >
    Switch to Manual
  </button>
</div>
